import * as api from "app/api/roles"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./roles.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getRolesFlow(): SagaIterator {
  try {
    const response = yield call(api.getRoles)
    yield put(actions.getRolesSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getRolesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* rolesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getRolesFlow)
}
